document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".accordion-toggle").forEach((toggle) => {
      toggle.addEventListener("click", function () {
        const content = this.nextElementSibling;
    
        if (content.classList.contains("open")) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
    
        content.classList.toggle("open");
        this.classList.toggle("open");
      });
    });
  });
  